var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("font-awesome-icon", {
        staticClass: "icon",
        attrs: { icon: _vm.icon, "fixed-width": "" },
      }),
      _vm._v(" "),
      _c("span", { staticClass: "visibility-label" }, [
        _vm._v(_vm._s(_vm.visibility)),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }